// Re-export IMAGE_PREFIX from main constants
import { transformMedia } from "../../utils/mediaTransform";
import { CDN_CREATOR_MASTER, IMAGE_PREFIX } from "../../utils/constants";
export { transformMedia, CDN_CREATOR_MASTER, IMAGE_PREFIX };

export const BORDER_RADIUS = "8px";

export const BOTTOM_SHEET_BORDER_RADIUS = "20px";
export const BOTTOM_SHEET_Z_INDEX = 1001;
export const SELECT_BY_WISHLINK_BRAND_ID = 2259;
export const MEESHO_PILOT_3_BRAND_ID = 251;
export const TOP_NAV_Z_INDEX = 100;
export const TOAST_Z_INDEX = 10000000000;

export const BANK_ICONS = {
  AIRP: "airtel-bank.png",
  UTIB: "axis-bank.png",
  BARB: "bob-bank.png",
  BKID: "boi-bank.png",
  MAHB: "bom-bank.png",
  CNRB: "canara-bank.png",
  CBIN: "central-bank.png",
  FDRL: "federal-bank.png",
  HDFC: "hdfc.png",
  ICIC: "icici-bank.png",
  IDIB: "idb-bank.png",
  IBKL: "idb-bank.png",
  IDFB: "idfc-bank.png",
  IPOS: "india-post-bank.png",
  INDB: "indusland-bank.png",
  KKBK: "kotak.png",
  IOBA: "overseas-bank.png",
  PUNB: "pnb.png",
  SBIN: "sbi.png",
  UCBA: "uco-bank.png",
  UBIN: "union-bank.png",
  YESB: "yes-bank.png",
} as const;

// Default bank icon for unknown IFSC codes
export const DEFAULT_BANK_ICON = "bank-icon.png";

export const DEFAULT_BAR_COUNT = 60;
export const PLAY_EVENT = "wish-ui-audio-player-play";

export const getAssetUrl = (assetUrl: string) => {
  const url = IMAGE_PREFIX + assetUrl;
  return transformMedia(url);
};

export function clamp01(n: number) {
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.min(1, n));
}

export function formatTime(seconds: number) {
  if (!Number.isFinite(seconds) || seconds < 0) return "0:00";
  const s = Math.floor(seconds);
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${r.toString().padStart(2, "0")}`;
}

export function normalizeBars(bars: number[]) {
  const safe = bars.map((b) => (Number.isFinite(b) ? b : 0));
  const max = Math.max(...safe, 0.000001);
  return safe.map((b) => clamp01(b / max));
}

export function barsFromAudioBuffer(
  audioBuffer: AudioBuffer,
  barCount: number
) {
  const channel = audioBuffer.getChannelData(0);
  const total = channel.length;
  const bucketSize = Math.max(1, Math.floor(total / barCount));

  const out: number[] = new Array(barCount).fill(0);
  for (let i = 0; i < barCount; i++) {
    const start = i * bucketSize;
    const end = Math.min(total, start + bucketSize);
    let peak = 0;
    for (let j = start; j < end; j++) {
      const v = Math.abs(channel[j]);
      if (v > peak) peak = v;
    }
    out[i] = peak;
  }
  return normalizeBars(out);
}

export const isFlatOrUptoCommission = (brand: any, isDrawer = false) => {
  const isFlat = Boolean(
    brand?.min_commission === brand?.max_commission &&
      !brand?.commission_additional_info_text?.length &&
      !brand?.category_wise_commissions?.length &&
      brand?.min_commission !== "0%"
  );

  if (isDrawer) {
    return isFlat;
  } else {
    // Meesho rate is the direct-order commission; indirect orders pay less, so show "Upto" (0% stays flat)
    if (brand?.brand_id === MEESHO_PILOT_3_BRAND_ID)
      return !(Number(brand?.max_commission) > 0);
    else return isFlat;
  }
};

export const isZeroCommission = (brand: any) => {
  return brand.newCommission === "0%" && brand.oldCommission === "0%";
};
